module.exports = __webpack_public_path__ + "img/max-good-logo.7103802f.svg";